import React from 'react';
import { cn } from '@rsc/tailwind-base/utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  iconComponent?: React.ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      disabled = false,
      hasError = false,
      readOnly = false,
      type,
      iconComponent,
      ...props
    },
    ref
  ) => {
    const outlineClass =
      'focus:outline focus:outline-2 focus:outline-ring focus:outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2';

    return (
      <div className="relative flex items-center w-full">
        {iconComponent && (
          <span
            aria-hidden="true"
            className={cn(
              'absolute left-3',
              hasError ? 'text-destructive' : 'text-input-icon'
            )}
          >
            {iconComponent}
          </span>
        )}
        <input
          className={cn(
            `flex h-11 w-full px-3 py-2 rounded-md text-input-foreground ${
              hasError
                ? 'border border-destructive text-input-foreground-destructive'
                : 'border border-input'
            } bg-white text-base ring-offset-white placeholder:text-input-placeholder disabled:cursor-not-allowed disabled:opacity-50 ${
              readOnly || disabled
                ? 'cursor-default caret-transparent focus:outline-none focus-visible:outline-none'
                : outlineClass
            } ${iconComponent ? 'pl-10' : 'pl-3'}`, // Adjust padding if icon is present
            className
          )}
          disabled={disabled}
          readOnly={readOnly}
          ref={ref}
          type={type}
          {...props}
        />
      </div>
    );
  }
);
